import React from "react";
import { withStyles } from "@material-ui/core/styles";
import CommonModalV2, { modalWidth } from "./commonModal/v2";
// import ExitAlertModal from "./exitAlertModal";
import ModalExitAlert from "./modalExitAlert";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import { generateEmailTemplateList, selectedProductIds, convertIntoEmail } from '../../utils/emailTemplates';
import { FEATURE } from '../../utils/feature';
import DenyAndEmailStyle from "../../styles/denyAndEmailStyle";

const SubmitButtonRef = React.createRef();
const hasFeature = FEATURE();

class DenyAndEmail extends React.Component {
    state = {
        subjectLineError: false,
        emailMessageError: false,
        denialReasonValueError: false,
        denialReasonTextError: false,
        exitModalOpen: false,
        isChangeMade: false
    }
    componentDidMount() {
        const {
            GetEmailTemplate = async () => {},
            GetEmailTemplateFromSalesforce = async () => {},
            GetDenialReasons = async () => {},
            SetDenialAndSendValue = async () => {},
            productInfo = {},
            selectedCardData = {},
        } = this.props;
        const { OrderId = "", StoreFrontURL = "", productIds = [], StoreFrontData = {} } = productInfo;
        GetDenialReasons(selectedCardData);

        const subjectDefaultValue = `${StoreFrontURL}; Order #${OrderId}`
        SetDenialAndSendValue({ name: "subjectLine", value: subjectDefaultValue });
        GetEmailTemplate({ DoctorID: localStorage.getItem('userId'), OrderId: productInfo.OrderId });
        GetEmailTemplateFromSalesforce({
            productIds,
            storefrontId: StoreFrontData.StorefrontId,
            action: 'Deny',
            orderId: OrderId
        });
    }

    UNSAFE_componentWillUnmount() {
        let { ClearEmailAndDenyData } = this.props;
        ClearEmailAndDenyData && ClearEmailAndDenyData();
        this.setState({ isChangeMade: false });
    }

    handleDenialReasonBlur = (e) => {
        if (e.target.value === -1 || e.target.value === "-1") {
            this.setState({ denialReasonValueError: true })
        } else if (this.state.denialReasonValueError) {
            this.setState({ denialReasonValueError: false })
        }
    }

    handleSubjectLineBlur = (e) => {
        let value = e.target.value.trim();
        if (value === "") {
            this.setState({ subjectLineError: true })
        } else if (this.state.subjectLineError) {
            this.setState({ subjectLineError: false })
        }
    }

    handleEmailMessageBlur = (e) => {
        let value = e.target.value.trim();
        if (value === "") {
            this.setState({ emailMessageError: true })
        } else if (this.state.emailMessageError) {
            this.setState({ emailMessageError: false })
        }
    }

    handleDenialReasonTextBlur = (e) => {
        let value = e.target.value.trim();
        if (value === "") {
            this.setState({ denialReasonTextError: true })
        } else if (this.state.denialReasonTextError) {
            this.setState({ denialReasonTextError: false })
        }
    }

    handleEmailTemplateChange = (e) => {
        const {
            SetDenialAndSendValue = async () => {},
            GetSubjectAndMailFromSalesforce = async () => {},
            GetSubjectAndMail = async () => {},
            emailTemplateValue = -1,
            productInfo = {},
        } = this.props;
        const value = parseInt(e.target.value);
        if (!this.state.isChangeMade && e.target.value !== emailTemplateValue) {
            this.setState({ isChangeMade: true })
        }
        SetDenialAndSendValue({ name: "emailTemplateValue", value });
        GetSubjectAndMailFromSalesforce({ messageId: value });
        switch (`${hasFeature.PULL_EMAIL_TEMPLATES_FROM_SALESFORCE}`) {
            case 'true': {
                GetSubjectAndMailFromSalesforce({ messageId: value });
                break;
            }
            case 'false': {
                if (value !== -1) {
                    GetSubjectAndMail({ DoctorID: localStorage.getItem('userId'), OrderId: productInfo.OrderId }, value);
                }
                break;
            }
            default: {
                break;
            }
        }
    }

    handleSubjectLine = (e) => {
        let { SetDenialAndSendValue } = this.props;
        if (!this.state.isChangeMade) {
            this.setState({ isChangeMade: true })
        }
        SetDenialAndSendValue && SetDenialAndSendValue({ name: "subjectLine", value: e.target.value })
    }

    handleEmailMessage = (e) => {
        let { SetDenialAndSendValue } = this.props;
        if (!this.state.isChangeMade) {
            this.setState({ isChangeMade: true })
        }
        SetDenialAndSendValue && SetDenialAndSendValue({ name: "emailMessage", value: e.target.value })
    }

    componentDidUpdate(prevProps) {
        if (this.state.emailMessageError && this.props.emailMessage && this.props.emailMessage.trim()) {
            this.setState({ emailMessageError: false })
        }
        if (this.state.subjectLineError && this.props.subjectLine && this.props.subjectLine.trim()) {
            this.setState({ subjectLineError: false })
        }
        if (this.state.denialReasonTextError && this.props.denialReasonText && this.props.denialReasonText.trim()) {
            this.setState({ denialReasonTextError: false })
        }
    }

    handleDenialReason = (e) => {
        let { SetDenialAndSendValue, denialReasonValue } = this.props;
        if (!this.state.isChangeMade && e.target.value !== denialReasonValue) {
            this.setState({ isChangeMade: true })
        }
        SetDenialAndSendValue && SetDenialAndSendValue({ name: "denialReasonValue", value: e.target.value })
    }

    handleDenialReasonText = (e) => {
        let { SetDenialAndSendValue } = this.props;
        if (!this.state.isChangeMade) {
            this.setState({ isChangeMade: true })
        }
        SetDenialAndSendValue && SetDenialAndSendValue({ name: "denialReasonText", value: e.target.value })
    }

    onDenialButtonClick = (e) => {
        let { denialReasonValue, denialReason = [], denialReasonText, emailTemplateValue, subjectLine, emailMessage, DenialAndEmail, selectedCardData = {},
            productInfo = {}, handleRouteChange, routePath, callStarted } = this.props, denialReasonString = "";
        for (let i = 0; i < denialReason.length; i++) {
            if (denialReasonValue === denialReason[i].AltItem) {
                denialReasonString = denialReason[i].Description;
                break;
            }
        }
        let data = {
            "OrderId": productInfo.OrderId,
            "PatientId": selectedCardData.UserId,
            "EmailTemplateId": emailTemplateValue,
            "EmailSubject": subjectLine,
            "EmailMessage": convertIntoEmail(emailMessage),
            "DenialReasonId": denialReasonValue && parseInt(denialReasonValue),
            "DenialReason": denialReasonString,
            "DenialReasonText": denialReasonText
        };
        if (SubmitButtonRef && SubmitButtonRef.current) {
            SubmitButtonRef.current.blur && SubmitButtonRef.current.blur();
        }
        DenialAndEmail && DenialAndEmail(data, handleRouteChange, routePath, callStarted);
    }

    openAlertModal = () => {
        let { closeOpenDenyAndEmail } = this.props;
        if (!this.state.isChangeMade) {
            closeOpenDenyAndEmail && closeOpenDenyAndEmail();
        } else {
            this.setState({ exitModalOpen: true });
        }
    }

    closeAlertModal = () => {
        this.setState({ exitModalOpen: false });
    }

    onConfirmation = () => {
        let { closeOpenDenyAndEmail, ClearEmailAndDenyData } = this.props;
        this.setState({ exitModalOpen: false });
        ClearEmailAndDenyData && ClearEmailAndDenyData();
        closeOpenDenyAndEmail && closeOpenDenyAndEmail();
    }

    onKeyDown = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
        }
    }


    render() {
        let { openDenyAndEmail, classes, denialReasonValue, denialReason, denialReasonText = "",
            emailTemplateValue, subjectLine, emailMessage, isModalAlertOpen, SetModalAlertOpen, HandleGlobalValueChange,
            emailTemplatesV2,
            productInfo = {},
            emailTemplate = [],
        } = this.props;
        emailTemplateValue = parseInt(emailTemplateValue);
        denialReasonValue = parseInt(denialReasonValue);

        const emailTemplatesFromSF = generateEmailTemplateList(emailTemplatesV2, selectedProductIds(productInfo));
        const EmailTemplateCollection = new Map([
            [true, emailTemplatesFromSF],
            [false, (emailTemplate || [])],
        ]);

        return (
            <CommonModalV2 onGlobalValueChange={HandleGlobalValueChange} title="Deny and Send Email" open={openDenyAndEmail} toggleModal={this.openAlertModal}  style={{ width: modalWidth.l }}>
                <div data-view="deny-and-send-email-component-wrapper" className={classes.modalBody}>
                    <div className={classes.contentWrapper}>
                        <div id="deny-email-template" className={classes.titleText}>EMAIL TEMPLATES:</div>
                        <FormControl variant="outlined" className={classes.productInput}>
                            <Select
                                labelId="customized-select-label"
                                id="deny-email-template-select"
                                MenuProps={{ classes: { paper: classes.menuItemWidth, list: classes.menuItemList } }}
                                classes={{ outlined: classes.productSelectStyle }}
                                value={emailTemplateValue}
                                onChange={this.handleEmailTemplateChange}
                                label={void 0}
                            >
                                <MenuItem
                                    title={"-- Choose --"}
                                    classes={{ selected: classes.menuItemSelected }}
                                    className={classes.menuItemRoot}
                                    value={-1}>
                                    -- Choose --
                                </MenuItem>
                                {EmailTemplateCollection.get(hasFeature.PULL_EMAIL_TEMPLATES_FROM_SALESFORCE).map((_, index) => {
                                    return <MenuItem
                                        title={_.EmailTemplateTitle}
                                        classes={{ selected: classes.menuItemSelected }}
                                        className={classes.menuItemRoot}
                                        key={index + _.EmailMessageId}
                                        value={_.EmailMessageId}>
                                        {_.EmailTemplateTitle}
                                    </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className={classes.contentWrapper}>
                        <div id="deny-email-template-subject" className={classes.titleText}>SUBJECT LINE:</div>
                        <textarea
                            wrap="soft"
                            id="deny-subjectLine"
                            onKeyDown={this.onKeyDown}
                            maxLength={255}
                            value={subjectLine}
                            onBlur={this.handleSubjectLineBlur}
                            onChange={this.handleSubjectLine}
                            type="text"
                            className={`${this.state.subjectLineError ? classes.textInputError : classes.textInput} subjectInput`}
                        />
                    </div>
                    <div className={classes.contentWrapperNoAlign}>
                        <div id="deny-email-template-email-message" className={classes.titleTextEmail}>EMAIL MESSAGE:</div>
                        <textarea
                            maxLength={65535}
                            spellCheck={true}
                            id="deny-emailMessage"
                            onBlur={this.handleEmailMessageBlur}
                            value={emailMessage}
                            onChange={this.handleEmailMessage}
                            className={this.state.emailMessageError ? classes.textAreaError : classes.textArea}
                        />
                    </div>
                    <div className={classes.contentWrapper}>
                        <div className="flex flex-column">
                            <div id="deny-email-template-reason" className={classes.titleText}>DENIAL REASON:</div>
                            <span className='font-10'>(Internal Use Only)</span>
                        </div>
                        <FormControl variant="outlined" className={this.state.denialReasonValueError ? classes.productInputError : classes.productInput}>
                            <Select
                                labelId="customized-select-label"
                                id="deny-reason-select"
                                onBlur={this.handleDenialReasonBlur}
                                MenuProps={{ classes: { paper: classes.menuItemWidth, list: classes.menuItemList } }}
                                classes={{ outlined: classes.productSelectStyle }}
                                value={denialReasonValue}
                                onChange={this.handleDenialReason}
                                label={void 0}
                            >
                                <MenuItem
                                    title={"-- Choose Denial Reason --"}
                                    classes={{ selected: classes.menuItemSelected }}
                                    className={classes.menuItemRoot}
                                    value={-1}>
                                    -- Choose Denial Reason --
                                </MenuItem>
                                {denialReason && denialReason.map((_, index) => {
                                    return <MenuItem title={_.Description} classes={{ selected: classes.menuItemSelected }} className={classes.menuItemRoot} key={index + _.AltItem} value={_.AltItem}>{_.Description}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className={classes.contentWrapperNoAlign}>
                        <div className={classes.titleTextEmail}></div>
                        <textarea
                            id="deny-reason-text"
                            maxLength={4000}
                            onBlur={this.handleDenialReasonTextBlur}
                            value={denialReasonText}
                            onChange={this.handleDenialReasonText}
                            className={this.state.denialReasonTextError ? classes.textAreaReasonError : classes.textAreaReason}
                            placeholder='Brief Description:'
                        />
                    </div>
                    <div className={classes.modalActionWrapper}>
                        <Button
                            disabled={
                                denialReasonValue === -1 ||
                                denialReasonText.trim() === "" ||
                                subjectLine.trim() === "" ||
                                emailMessage.trim() === ""
                            }
                            id="deny-and-send-button"
                            ref={SubmitButtonRef}
                            onClick={this.onDenialButtonClick}
                            variant="contained" color="primary"
                            className={classes.buttonStyle}>
                            Deny & Send Email
                        </Button>
                        <Button
                            id="deny-and-send-cancel-button"
                            onClick={this.openAlertModal}
                            variant="contained"
                            color="primary"
                            className={classes.cancelButtonStyle}>
                            Cancel
                        </Button>
                    </div>
                </div>
                <ModalExitAlert type="confirmation" onConfirmation={this.onConfirmation} modalOpen={this.state.isChangeMade && this.state.exitModalOpen} closeModal={this.closeAlertModal} />
                <ModalExitAlert type="alert" modalOpen={isModalAlertOpen} closeModal={() => SetModalAlertOpen(false)} />
            </CommonModalV2>
        )
    }
}


export default withStyles(DenyAndEmailStyle)(DenyAndEmail);

